// The viewer's photo info (#379): the lines of the ⓘ panel for an attachment, from the `photo` record the server stores with a
// picture. The record is untrusted (it comes from the file), so `formatPhotoInfo` checks it again; the lines are plain text.
import { formatPhotoInfo, type Attachment, type PhotoLines } from "@bloom/shared";
import { isImage } from "./upload.ts";

/** The three lines for a picture with camera info, or undefined: no ⓘ button, no panel. */
export function viewerPhoto(a: Attachment): PhotoLines | undefined {
  if (a.kind !== "file" || !isImage(a.type)) return undefined;
  return formatPhotoInfo(a.photo) ?? undefined;
}
